import template from './routes.edit.html';
import controller from './routes.edit.controller';
import './routes.edit.scss';

let routeseditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default routeseditComponent;


// WEBPACK FOOTER //
// ./client/app/components/routes/edit/routes.edit.component.js